module.exports = __webpack_public_path__ + "static/media/plus-thumbnail.c314cb31.png";